import { render, staticRenderFns } from "./SBButtonSmall.html?vue&type=template&id=0b17214e&scoped=true&"
import script from "./SBButtonSmall.ts?vue&type=script&lang=ts&"
export * from "./SBButtonSmall.ts?vue&type=script&lang=ts&"
import style0 from "./SBButtonSmall.css?vue&type=style&index=0&id=0b17214e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17214e",
  null
  
)

export default component.exports